import React from 'react';
import { Section } from './ui/Section';
import { Button } from './ui/Button';
import { Calculator, FileText, Building2, Users, Receipt, BookOpen, ArrowUpRight } from 'lucide-react';
import { useLang } from '../contexts/LanguageContext';
export function Services() {
  const {
    t
  } = useLang();
  const scrollToContact = () => document.getElementById('contact')?.scrollIntoView({
    behavior: 'smooth'
  });
  return <Section id="services" background="white" data-id="element-284">
      <div className="flex flex-col md:flex-row justify-between items-start md:items-end mb-12 md:mb-24 gap-4 md:gap-6" data-id="element-285">
        <div className="max-w-2xl" data-id="element-286">
          <h2 className="text-2xl sm:text-3xl md:text-5xl font-bold text-black mb-4 md:mb-6" data-id="element-287">
            {t('services_h2')}
          </h2>
          <p className="text-neutral-500 text-base md:text-lg font-light" data-id="element-288">
            {t('services_subtitle')}
          </p>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 border-t border-l border-neutral-200" data-id="element-289">
        {/* Service 1 */}
        <div className="group p-6 md:p-8 border-r border-b border-neutral-200 hover:bg-neutral-50 transition-all duration-300 cursor-pointer relative" onClick={scrollToContact} data-id="element-290">
          <div className="absolute top-6 md:top-8 right-6 md:right-8 opacity-0 group-hover:opacity-100 group-hover:translate-x-1 group-hover:-translate-y-1 transition-all duration-300" data-id="element-291">
            <ArrowUpRight className="h-4 md:h-5 w-4 md:w-5 text-black" data-id="element-292" />
          </div>
          <div className="mb-6 md:mb-8 group-hover:scale-110 transition-transform duration-300 origin-left" data-id="element-293">
            <Calculator className="h-5 md:h-6 w-5 md:w-6 text-black stroke-[1.5]" data-id="element-294" />
          </div>
          <h3 className="text-lg md:text-xl font-bold text-black mb-3 group-hover:underline decoration-1 underline-offset-4 transition-all" data-id="element-295">
            {t('svc1_title')}
          </h3>
          <p className="text-neutral-500 mb-6 md:mb-8 text-sm leading-relaxed min-h-[3rem]" data-id="element-296">
            {t('svc1_desc')}
          </p>
          <div className="flex items-center" data-id="element-297">
            <span className="text-black font-medium text-sm border-b border-neutral-200 group-hover:border-black transition-colors pb-0.5" data-id="element-298">
              {t('svc1_price')}
            </span>
          </div>
        </div>

        {/* Service 2 */}
        <div className="group p-6 md:p-8 border-r border-b border-neutral-200 hover:bg-neutral-50 transition-all duration-300 cursor-pointer relative" onClick={scrollToContact} data-id="element-299">
          <div className="absolute top-6 md:top-8 right-6 md:right-8 opacity-0 group-hover:opacity-100 group-hover:translate-x-1 group-hover:-translate-y-1 transition-all duration-300" data-id="element-300">
            <ArrowUpRight className="h-4 md:h-5 w-4 md:w-5 text-black" data-id="element-301" />
          </div>
          <div className="mb-6 md:mb-8 group-hover:scale-110 transition-transform duration-300 origin-left" data-id="element-302">
            <FileText className="h-5 md:h-6 w-5 md:w-6 text-black stroke-[1.5]" data-id="element-303" />
          </div>
          <h3 className="text-lg md:text-xl font-bold text-black mb-3 group-hover:underline decoration-1 underline-offset-4 transition-all" data-id="element-304">
            {t('svc2_title')}
          </h3>
          <p className="text-neutral-500 mb-6 md:mb-8 text-sm leading-relaxed min-h-[3rem]" data-id="element-305">
            {t('svc2_desc')}
          </p>
          <div className="flex items-center" data-id="element-306">
            <span className="text-black font-medium text-sm border-b border-neutral-200 group-hover:border-black transition-colors pb-0.5" data-id="element-307">
              {t('svc2_price')}
            </span>
          </div>
        </div>

        {/* Service 3 */}
        <div className="group p-6 md:p-8 border-r border-b border-neutral-200 hover:bg-neutral-50 transition-all duration-300 cursor-pointer relative" onClick={scrollToContact} data-id="element-308">
          <div className="absolute top-6 md:top-8 right-6 md:right-8 opacity-0 group-hover:opacity-100 group-hover:translate-x-1 group-hover:-translate-y-1 transition-all duration-300" data-id="element-309">
            <ArrowUpRight className="h-4 md:h-5 w-4 md:w-5 text-black" data-id="element-310" />
          </div>
          <div className="mb-6 md:mb-8 group-hover:scale-110 transition-transform duration-300 origin-left" data-id="element-311">
            <Building2 className="h-5 md:h-6 w-5 md:w-6 text-black stroke-[1.5]" data-id="element-312" />
          </div>
          <h3 className="text-lg md:text-xl font-bold text-black mb-3 group-hover:underline decoration-1 underline-offset-4 transition-all" data-id="element-313">
            {t('svc3_title')}
          </h3>
          <p className="text-neutral-500 mb-6 md:mb-8 text-sm leading-relaxed min-h-[3rem]" data-id="element-314">
            {t('svc3_desc')}
          </p>
          <div className="flex items-center" data-id="element-315">
            <span className="text-black font-medium text-sm border-b border-neutral-200 group-hover:border-black transition-colors pb-0.5" data-id="element-316">
              {t('svc3_price')}
            </span>
          </div>
        </div>

        {/* Service 4 */}
        <div className="group p-6 md:p-8 border-r border-b border-neutral-200 hover:bg-neutral-50 transition-all duration-300 cursor-pointer relative" onClick={scrollToContact} data-id="element-317">
          <div className="absolute top-6 md:top-8 right-6 md:right-8 opacity-0 group-hover:opacity-100 group-hover:translate-x-1 group-hover:-translate-y-1 transition-all duration-300" data-id="element-318">
            <ArrowUpRight className="h-4 md:h-5 w-4 md:w-5 text-black" data-id="element-319" />
          </div>
          <div className="mb-6 md:mb-8 group-hover:scale-110 transition-transform duration-300 origin-left" data-id="element-320">
            <Users className="h-5 md:h-6 w-5 md:w-6 text-black stroke-[1.5]" data-id="element-321" />
          </div>
          <h3 className="text-lg md:text-xl font-bold text-black mb-3 group-hover:underline decoration-1 underline-offset-4 transition-all" data-id="element-322">
            {t('svc4_title')}
          </h3>
          <p className="text-neutral-500 mb-6 md:mb-8 text-sm leading-relaxed min-h-[3rem]" data-id="element-323">
            {t('svc4_desc')}
          </p>
          <div className="flex items-center" data-id="element-324">
            <span className="text-black font-medium text-sm border-b border-neutral-200 group-hover:border-black transition-colors pb-0.5" data-id="element-325">
              {t('svc4_price')}
            </span>
          </div>
        </div>

        {/* Service 5 */}
        <div className="group p-6 md:p-8 border-r border-b border-neutral-200 hover:bg-neutral-50 transition-all duration-300 cursor-pointer relative" onClick={scrollToContact} data-id="element-326">
          <div className="absolute top-6 md:top-8 right-6 md:right-8 opacity-0 group-hover:opacity-100 group-hover:translate-x-1 group-hover:-translate-y-1 transition-all duration-300" data-id="element-327">
            <ArrowUpRight className="h-4 md:h-5 w-4 md:w-5 text-black" data-id="element-328" />
          </div>
          <div className="mb-6 md:mb-8 group-hover:scale-110 transition-transform duration-300 origin-left" data-id="element-329">
            <Receipt className="h-5 md:h-6 w-5 md:w-6 text-black stroke-[1.5]" data-id="element-330" />
          </div>
          <h3 className="text-lg md:text-xl font-bold text-black mb-3 group-hover:underline decoration-1 underline-offset-4 transition-all" data-id="element-331">
            {t('svc5_title')}
          </h3>
          <p className="text-neutral-500 mb-6 md:mb-8 text-sm leading-relaxed min-h-[3rem]" data-id="element-332">
            {t('svc5_desc')}
          </p>
          <div className="flex items-center" data-id="element-333">
            <span className="text-black font-medium text-sm border-b border-neutral-200 group-hover:border-black transition-colors pb-0.5" data-id="element-334">
              {t('svc5_price')}
            </span>
          </div>
        </div>

        {/* Service 6 */}
        <div className="group p-6 md:p-8 border-r border-b border-neutral-200 hover:bg-neutral-50 transition-all duration-300 cursor-pointer relative" onClick={scrollToContact} data-id="element-335">
          <div className="absolute top-6 md:top-8 right-6 md:right-8 opacity-0 group-hover:opacity-100 group-hover:translate-x-1 group-hover:-translate-y-1 transition-all duration-300" data-id="element-336">
            <ArrowUpRight className="h-4 md:h-5 w-4 md:w-5 text-black" data-id="element-337" />
          </div>
          <div className="mb-6 md:mb-8 group-hover:scale-110 transition-transform duration-300 origin-left" data-id="element-338">
            <BookOpen className="h-5 md:h-6 w-5 md:w-6 text-black stroke-[1.5]" data-id="element-339" />
          </div>
          <h3 className="text-lg md:text-xl font-bold text-black mb-3 group-hover:underline decoration-1 underline-offset-4 transition-all" data-id="element-340">
            {t('svc6_title')}
          </h3>
          <p className="text-neutral-500 mb-6 md:mb-8 text-sm leading-relaxed min-h-[3rem]" data-id="element-341">
            {t('svc6_desc')}
          </p>
          <div className="flex items-center" data-id="element-342">
            <span className="text-black font-medium text-sm border-b border-neutral-200 group-hover:border-black transition-colors pb-0.5" data-id="element-343">
              {t('svc6_price')}
            </span>
          </div>
        </div>
      </div>

      <div className="mt-16 md:mt-24 flex items-center gap-4" data-id="element-344">
        <div className="h-px flex-1 bg-neutral-200" data-id="element-345"></div>
        <span className="text-xs text-neutral-400 uppercase tracking-wider text-center px-2" data-id="element-346">
          {t('services_footer')}
        </span>
        <div className="h-px flex-1 bg-neutral-200" data-id="element-347"></div>
      </div>
    </Section>;
}